import React from "react";
import {
  Button,
  Carousel,
  // Carousel,
  // CarouselItem,
  Modal,
  Spinner,
} from "react-bootstrap";
import { MdOutlineClose } from "react-icons/md";
import { COLOR_APP, S3_URL } from "../constants";
import CarouselImage from "./CarouselImage";
import useWindowDimensions from "../helpers/useWindowDimensions";

export default function AdvertisingComponent({
  showAdverModl,
  handleCloseAdverModl,
  systemNotices,
  handleClickSystemNotice,
  noticeLoading,
}) {
  const { height, width } = useWindowDimensions();

  const handleClickImage = (e, data) => {
    // console.log({ data });
    handleClickSystemNotice(e, data);
    handleCloseAdverModl();
  };

  // 10,000
  // 100
  //

  // console.log("check systemNotices:-->", systemNotices);

  if (noticeLoading)
    return (
      <div
        style={{
          width: "100%",
          height: "30vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Spinner size="lg" />
      </div>
    );

  return (
    <>
      <Modal centered show={showAdverModl} size="lg">
        <div className="close-button" onClick={handleCloseAdverModl}>
          <MdOutlineClose />
        </div>
        <Modal.Body>
          <div className="system-notice-popup">
            <div
              style={{ width: width > 700 ? 770 : 400 }}
              className="system-image"
            >
              <Carousel
                autoPlay={10000}
                pause={false}
                // nextIcon={null}
                // prevIcon={null}
              >
                {systemNotices.map((data, index) => (
                  <Carousel.Item key={index}>
                    <img
                      src={S3_URL + data?.details[0]?.images[0]}
                      style={{ width: "100%", height: width > 700 ? 400 : 180 }}
                    />

                    <Carousel.Caption>
                      <div className="actions-btn-overview">
                        <Button
                          style={{
                            background: COLOR_APP,
                            color: "#fff",
                            border: "4px solid white",
                          }}
                          onClick={(e) => handleClickImage(e, data)}
                        >
                          ອ່ານເພິ່ມເຕີມ
                        </Button>
                      </div>
                    </Carousel.Caption>
                  </Carousel.Item>
                ))}
              </Carousel>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
